import { getApiBaseUrl } from '../../../utils/apiBaseUrl';

export const rushMidAvatarUrl = (userId?: string | null): string | undefined =>
  userId ? `${getApiBaseUrl()}/api/users/avatar/${userId}` : undefined;
